export default __webpack_public_path__ + "static/media/payment-failed.fa16e973.svg";